<template>
    <div style="background-color: white; min-height: 100vh; padding-bottom: 20px;" class="d-md-none d-lg-none">
    <CContainer class="receipt-container">
      <!-- Back Button -->
      <CButton color="link" class="back-button" @click="$router.go(-1)">
        <CIcon name="cil-arrow-left" size="xl" />
      </CButton>
  
      <!-- Page Title -->
      <h2 class="title">Receipt</h2>
  
      <!-- Payment Success Section -->
      <div class="success-section">
        <img src="@/assets/img/new/success-icon.png" alt="Success" class="success-icon" style="max-width:100%"/>
        <h3 class="success-title">Payment Success</h3>
      </div>
  
      <!-- Payment Details Card -->
      <CCard class="receipt-card">
        <CCardBody>
          <p>No order <strong>#20049999</strong></p>
          <div class="details">
            <div class="detail-row">
              <span>No references</span> <span>12345678910111213</span>
            </div>
            <div class="detail-row">
              <span>Payment code</span> <span>Monyetpay Card</span>
            </div>
            <div class="detail-row">
              <span>Date</span> <span>Jan 06, 2025</span>
            </div>
            <div class="detail-row">
              <span>Time</span> <span>10:00 AM</span>
            </div>
            <div class="detail-row total">
              <span>Total</span> <span>$9.90</span>
            </div>
          </div>
        </CCardBody>
      </CCard>
  
      <CButton class="custom-border-purple" color="primary" block @click="goHome()">
        Go Home
      </CButton>
    </CContainer>
</div>
  </template>
  
  <script>
  export default {
    methods: {
      goHome() {
        this.$router.push("/home"); // Change this to your actual home route
      }
    }
  };
  </script>
  
  <style scoped>
  .receipt-container {
    text-align: center;
    padding: 20px;
  }
  
  .back-button {
    position: absolute;
    left: 10px;
    top: 10px;
  }
  
  .title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  
  .success-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
  }
  
 
  
  .success-title {
    font-size: 18px;
    font-weight: bold;
    margin-top: 10px;
  }
  
  .receipt-card {
    background: #f9f9ff;
    border-radius: 16px;
    padding: 16px;
    text-align: left;
  }
  
  .details {
    margin-top: 10px;
  }
  
  .detail-row {
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
    font-size: 14px;
    color: #666;
  }
  
  .total {
    font-weight: bold;
    font-size: 16px;
  }
  
  .home-button {
    margin-top: 20px;
    border-radius: 30px;
    font-size: 16px;
    font-weight: bold;
    height: 50px;
  }
  </style>